<template>
  <ul class="wrapper" style="margin-left: 30px">
    <li
      class="item"
      v-show="!item.hidden"
      :key="item.id"
      v-for="(item, index) in router"
    >
      <div>
        <Icon
          v-show="item.childList.length > 0"
          :type="item.showHide ? 'ios-arrow-up' : 'ios-arrow-down'"
          style="font-size: 16px"
          @click="item.showHide = !item.showHide"
        />
        <Checkbox v-model="item.enabled" @on-change="first(item)">
          {{ item.name }}
          <Tag :color="item.type == 1 ? 'blue' : 'red'">
            {{ item.type == 1 ? "菜单" : "功能" }}
          </Tag>
        </Checkbox>
      </div>

      <template v-if="item.childList.length > 0">
        <my-menu
          :router="item.childList"
          :parent-node="item"
          v-if="item.showHide"
        ></my-menu>
      </template>
    </li>
  </ul>
</template>

<script>
export default {
  name: "myMenu",
  props: {
    router: {
      type: Array,
      required: true
    },
    parentNode: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      toggleShow: false
    };
  },
  methods: {
    handleToggleShow() {
      this.toggleShow = !this.toggleShow;
    },
    first(row) {
      console.log("paren1", this.parentNode);
      // 同步所有父节点的enabled状态
      this.changeParnNode(row);
      // 同步所有子节点的enabled状态
      this.ddd(row);
    },
    ddd(datas) {
      for (let i = 0; i < datas.childList.length; i++) {
        datas.childList[i].enabled = datas.enabled;
        if (datas.childList[i].childList.length > 0) {
          this.ddd(datas.childList[i]);
        }
      }
    },
    changeParnNode(node) {
      if (node.enabled) {
        // 定义递归向上更新父节点的方法（修正语法错误，逻辑更清晰）
        const updateParentEnabled = parentNode => {
          // 父节点存在时才处理
          if (parentNode) {
            // 将父节点的enabled设为true
            parentNode.enabled = true;
            let arr = [];
            /* for (let i = 0; i < parentNode.childList.length; i++) {
              if (parentNode.childList[i].enabled) {
                arr.push(parentNode.childList[i].name);
              }
            } */

            // 找到上层my-menu组件，获取它的parentNode（祖父节点）
            // 循环查找上层的my-menu组件，避免非my-menu组件干扰

            const grandParentNode = this.$parent.parentNode;

            if (grandParentNode) {
              updateParentEnabled(grandParentNode);
            }
          }
        };

        // 先更新直接父节点
        if (this.parentNode) {
          updateParentEnabled(this.parentNode);
        } else {
          console.log("当前节点是根节点，无父级");
        }
      } else {
        console.log("当前节点enabled为false，不需要向上处理");
      }
    }
  }
};
</script>

<style>
.item-title {
  font-size: 16px;
}
.wrapper {
  list-style: none;
  padding: 0;
}
.item {
  margin: 5px 0;
}
</style>



// WEBPACK FOOTER //
// ../common/src/components/authorityMenu.vue